// COPIA DE LA TABLA1 PARA ENGLOBARLA EN UN DIV Y PONERLE SCROLL CUANDO NO ENTRE TODO EL CONTENIDO
$(function(){
	if ($(".tabla1").length > 0 ) {
		$(".tabla1").each(function() {
			$(this).after("<div style='overflow-x: auto;'><table class='tabla1'>" + $(this).html() + "</table></div>");
			$(this).remove();
		});
	}
})